import { HttpContextToken } from '@angular/common/http';

export const IS_CALENSO_AUTH_REQUIRED = new HttpContextToken<boolean>(() => false);
